// extracted by mini-css-extract-plugin
export default {"overlay":"oy-z","bodyOpen":"py-z","content":"qy-z","header":"ry-z","close":"sy-z","closeNoHeading":"ty-z"};